{
  "sidebar": {
    "title": "Sidebar",
    "mobileDescription": "Displays the mobile sidebar.",
    "toggle": "Toggle Sidebar"
  },
  "nav": {
    "employeeHub": "Employee hub",
    "timeOff": "Time off",
    "orgChart": "Org chart",
    "onboarding": "Onboarding",
    "dashboard": "Dashboard",
    "counters": "Counters",
    "users": "Users",
    "activityHistory": "Activity",
    "profile": "Profile",
    "settings": "Settings",
    "collapse": "Collapse",
    "logout": "Logout",
    "myWork": "Workspace",
    "pipeline": "Pipeline",
    "calendar": "Calendar",
    "clients": "Clients",
    "structure": "Structure",
    "team": "Team",
    "hr": "HR",
    "hrHome": "HR overview",
    "reviews": "Reviews"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "User",
    "cancel": "Cancel",
    "save": "Save",
    "dismiss": "Dismiss"
  },
  "login": {
    "title": "Welcome back",
    "description": "Enter your credentials to sign in to your account",
    "identifier": {
      "username": "Username",
      "email": "Email",
      "both": "Username or email",
      "placeholder": "Enter your {{field}}"
    },
    "password": {
      "label": "Password",
      "placeholder": "Enter your password"
    },
    "button": "Sign in",
    "button.loading": "Signing in...",
    "error": {
      "identifierRequired": "{{field}} is required",
      "passwordLength": "Password must be at least 6 characters",
      "failed": "Login failed",
      "unknown": "An unexpected error occurred"
    },
    "forgotPassword": "Forgot password?",
    "descriptionEmail": "Sign in with your work email",
    "descriptionPassword": "Enter your password to continue",
    "emailPlaceholder": "Enter your email",
    "change": "Change",
    "continue": "Continue",
    "or": "or",
    "google": "Continue with Google",
    "googleSoon": "Google sign-in isn't set up yet. Use your email for now.",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up"
  },
  "invitation": {
    "title": "Complete Your Registration",
    "description": "Set your password to activate your account",
    "username": "Username",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "confirmPassword": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "button": "Set Password & Activate",
    "button.loading": "Setting up...",
    "invalidTitle": "Invalid Invitation",
    "goToLogin": "Go to Login",
    "resetPassword": {
      "title": "Reset Your Password",
      "description": "Enter a new password for your account",
      "button": "Reset Password",
      "button.loading": "Resetting..."
    },
    "error": {
      "noToken": "No invitation token provided",
      "invalidToken": "Invalid or expired invitation token",
      "passwordLength": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords do not match",
      "failed": "Failed to set password. Please try again."
    }
  },
  "profile": {
    "title": "My Account",
    "subtitle": "Manage your profile and security settings",
    "edit": "Edit",
    "verified": "Verified",
    "updateSuccess": "Profile updated successfully",
    "updateError": "Failed to update profile",
    "info": {
      "title": "Profile Information",
      "description": "Your account details"
    },
    "field": {
      "name": "Full Name",
      "username": "Username",
      "email": "Email",
      "memberSince": "Member Since"
    },
    "editModal": {
      "title": "Edit Profile",
      "description": "Update your profile information"
    },
    "security": {
      "title": "Change Password",
      "description": "Update your password to keep your account secure",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "passwordMismatch": "Passwords do not match",
      "passwordInvalid": "Password does not meet requirements",
      "changeSuccess": "Password changed successfully. Other sessions have been logged out.",
      "changeError": "Failed to change password",
      "changeButton": "Change Password"
    },
    "sessions": {
      "currentSession": "Current Session",
      "current": "Current",
      "device": "Device",
      "ip": "IP Address",
      "lastActive": "Last Active",
      "now": "Now",
      "unknown": "Unknown",
      "otherSessions": "Other Sessions",
      "otherDescription": "Sessions active on other devices",
      "revokeAll": "Revoke All",
      "revoke": "Revoke",
      "revokeSuccess": "Session revoked successfully",
      "revokeError": "Failed to revoke session",
      "revokeAllSuccess": "All other sessions have been logged out",
      "revokeAllError": "Failed to revoke sessions",
      "noOtherSessions": "No other active sessions",
      "lastActiveAt": "Last active {{time}}",
      "neverActive": "Never active",
      "confirmRevokeAll": {
        "title": "Revoke All Sessions",
        "description": "This will log out all other devices. You will remain logged in on this device."
      },
      "time": {
        "daysAgo": "{{count}}d ago",
        "hoursAgo": "{{count}}h ago",
        "justNow": "just now",
        "minutesAgo": "{{count}}m ago"
      },
      "unknownBrowser": "Unknown browser",
      "unknownDevice": "Unknown device"
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Manage your application preferences",
    "theme": "Theme",
    "themeDescription": "Select your preferred theme",
    "language": "Language",
    "languageDescription": "Select your preferred language"
  },
  "users": {
    "title": "Users",
    "button": {
      "add": "Add User",
      "resetPassword": "Reset Password",
      "resendInvitation": "Resend Invitation",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "demoteFromAdmin": "Demote from Admin",
      "promoteToAdmin": "Promote to Admin",
      "delete": "Delete"
    },
    "table": {
      "username": "Username",
      "email": "Email",
      "name": "Name",
      "role": "Role",
      "status": "Status",
      "lastLogin": "Last Login",
      "created": "Created",
      "actions": "Actions",
      "noResults": "No users found",
      "roles": "Roles"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "date": {
      "never": "Never"
    },
    "actions": {
      "label": "Actions",
      "copyId": "Copy user ID",
      "editUser": "Edit user",
      "openMenu": "Open menu",
      "viewDetails": "View details"
    },
    "filter": {
      "allRoles": "All Roles",
      "allStatus": "All Status"
    },
    "search": {
      "placeholder": "Search by username..."
    },
    "error": {
      "create": "Failed to create user",
      "delete": "Failed to delete user",
      "resetPassword": "Failed to reset password",
      "resendInvitation": "Failed to resend invitation",
      "activate": "Failed to activate user",
      "demote": "Failed to demote user",
      "promote": "Failed to promote user",
      "deactivate": "Failed to deactivate user"
    },
    "role": {
      "USER": "User",
      "ADMIN": "Admin",
      "SUPERADMIN": "Super Admin"
    },
    "modal": {
      "add": {
        "title": "Add New User",
        "description": "Create a new user account. An invitation link will be generated.",
        "name": "Name",
        "namePlaceholder": "Enter full name...",
        "email": "Email",
        "emailPlaceholder": "Enter email...",
        "emailOptional": "Email (optional)",
        "identifierHint": "Enter a username, an email, or both — the user signs in with whichever you set.",
        "username": "Username",
        "usernamePlaceholder": "Enter username...",
        "role": "Role",
        "password": "Password (optional)",
        "passwordPlaceholder": "Leave empty to send invitation link",
        "passwordHint": "If left empty, an invitation link will be generated for the user to set their own password.",
        "button": "Create User",
        "rolePlaceholder": "Select a role"
      },
      "invitation": {
        "copied": "Link copied",
        "copyFailed": "Could not copy the link. Copy it manually.",
        "title": "Invitation Link",
        "message": "Share this link with the user to complete their registration.",
        "emailSent": "The invitation was emailed to {{email}}.",
        "emailFailed": "The invitation could not be emailed to {{email}}. Send the link below yourself.",
        "button": {
          "copy": "Copy Link",
          "done": "Done"
        }
      },
      "deactivate": {
        "title": "Deactivate User",
        "message": "Are you sure you want to deactivate {{username}}?",
        "button": "Deactivate"
      },
      "selfReset": {
        "title": "Reset Your Password",
        "message": "You are about to reset your own password. You will be logged out and need to use the invitation link to log back in.",
        "button": "Reset Password"
      },
      "button": {
        "cancel": "Cancel"
      },
      "delete": {
        "title": "Delete User",
        "message": "This deletes {{username}} for good and cannot be undone. The account is signed out everywhere and can never sign in again, and its username and email are freed for someone new. To only take access away, deactivate instead.",
        "confirm": "Type {{username}} to confirm",
        "button": "Delete User"
      }
    },
    "card": {
      "total": "total"
    },
    "pagination": {
      "of": "of",
      "page": "Page",
      "rowsPerPage": "Rows per page"
    }
  },
  "counters": {
    "title": "Counters",
    "description": "Manage your counters",
    "newCounter": "New Counter",
    "empty": "No counters yet. Create one to get started!",
    "lastUpdated": "Last updated:",
    "modal": {
      "title": "Create New Counter",
      "description": "Enter a name for your new counter.",
      "nameLabel": "Counter Name",
      "namePlaceholder": "Enter counter name...",
      "cancel": "Cancel",
      "create": "Create"
    },
    "clearAll": "Clear All",
    "clearAllModal": {
      "cancel": "Cancel",
      "confirm": "Delete All",
      "description": "Are you sure you want to delete all {{count}} counters? This action cannot be undone.",
      "title": "Clear All Counters"
    },
    "error": {
      "create": "Failed to create counter",
      "decrement": "Failed to decrement counter",
      "delete": "Failed to delete counter",
      "deleteAll": "Failed to delete all counters",
      "increment": "Failed to increment counter",
      "reset": "Failed to reset counter"
    },
    "loadError": "Could not load counters.",
    "noResults": "No counters match your search.",
    "search": "Search counters...",
    "toast": {
      "incremented": "Counter incremented"
    },
    "total": "total"
  },
  "activity": {
    "table": {
      "timestamp": "Timestamp",
      "action": "Action",
      "entityType": "Entity Type",
      "user": "User",
      "ip": "IP Address",
      "status": "Status",
      "noResults": "No activity logs found"
    },
    "status": {
      "success": "Success",
      "failed": "Failed"
    },
    "filter": {
      "clear": "Clear",
      "allActions": "All Actions",
      "allEntities": "All Entities",
      "allStatus": "All Status"
    },
    "entityType": {
      "session": "Session",
      "user": "User",
      "counter": "Counter"
    },
    "action": {
      "LOGIN": "Login",
      "LOGIN_FAILED": "Login Failed",
      "LOGOUT": "Logout",
      "LOGOUT_ALL": "Logout All",
      "TOKEN_REFRESH": "Token Refresh",
      "CREATE": "Create",
      "UPDATE": "Update",
      "DELETE": "Delete",
      "PASSWORD_SET": "Password Set",
      "PASSWORD_CHANGE": "Password Change",
      "PASSWORD_RESET": "Password Reset",
      "REGISTER": "Register",
      "EMAIL_VERIFY": "Email Verify",
      "RESEND_VERIFICATION": "Resend Verification"
    },
    "search": {
      "placeholder": "Search by username, IP, entity..."
    },
    "button": {
      "details": "Details"
    },
    "modal": {
      "title": "Activity Details"
    },
    "details": {
      "error": "Error",
      "previousState": "Previous State",
      "newState": "New State",
      "metadata": "Metadata",
      "userAgent": "User Agent"
    },
    "pagination": {
      "of": "of",
      "page": "Page",
      "rowsPerPage": "Rows per page"
    }
  },
  "activityHistory": {
    "title": "Activity History",
    "description": "View system audit logs and user activity",
    "card": {
      "total": "entries"
    }
  },
  "toast": {
    "sessionExpired": "Session expired. Please log in again.",
    "deviceMismatch": "This session belongs to another device. Please log in again.",
    "rateLimited": "Too many requests. Please try again later.",
    "reconnecting": "Reconnecting…",
    "unreachable": "We couldn't reach the server — it may be restarting. Nothing was saved; please try again in a moment."
  },
  "error500": {
    "title": "500 Server Error",
    "subtitle": "Something went wrong on our end",
    "description": "We apologize for the inconvenience. The server encountered an internal error and was unable to complete your request. Our team has been notified.",
    "tryAgain": "Try Again",
    "goHome": "Go Home",
    "errorCode": "Error code"
  },
  "backend": {
    "accountLocked": "Too many failed login attempts. Try again in {{seconds}} seconds",
    "accountLockedTitle": "Account temporarily locked",
    "badRequest": "The request was invalid",
    "cannotAssignCustomerRole": "The Customer role cannot be assigned to admin-managed users",
    "cannotDeactivateOwnAccount": "You cannot deactivate your own account",
    "cannotDeleteOwnAccount": "You cannot delete your own account",
    "cannotDeleteSuperAdmin": "Super Admin users cannot be deleted",
    "cannotModifyOwnRoles": "You cannot modify your own roles",
    "cannotModifyOwnSuperAdmin": "You cannot modify your own Super Admin status",
    "cannotResendSuperAdminInvitation": "Invitations cannot be resent for Super Admin users",
    "cannotResetSuperAdminPassword": "The password of a Super Admin cannot be reset here",
    "cannotUpdateSuperAdmin": "Super Admin users cannot be updated",
    "conflict": "This already exists",
    "counterNotFound": "Counter not found",
    "currentPasswordIncorrect": "Current password is incorrect",
    "emailAlreadyVerified": "This email is already verified. You can log in.",
    "emailExists": "This email is already registered",
    "emailNotVerified": "Please verify your email before logging in",
    "emailRequired": "Email is required",
    "fetchActivityFailed": "Could not load activity",
    "fetchProfileFailed": "Could not load your profile",
    "fetchSessionsFailed": "Could not load your sessions",
    "fetchUsersFailed": "Could not load users",
    "forbidden": "You don't have permission to do that",
    "identifierInUse": "That username or email is already in use",
    "identifierRequired": "Username or email is required",
    "invalidCredentials": "Invalid username or password",
    "invalidEmail": "Invalid email format",
    "invalidInvitationToken": "Invalid or expired invitation link",
    "invalidResetToken": "This password reset link is invalid or has expired",
    "invalidVerificationToken": "This verification link is invalid or has expired",
    "logoutAllFailed": "Could not log out the other sessions",
    "logoutFailed": "Logout failed",
    "newPasswordSameAsCurrent": "New password must be different from current password",
    "noPlatformAccess": "Your account does not have access to this application",
    "notFound": "Not found",
    "onlySuperAdminsCreateSuperAdmins": "Only Super Admins can create Super Admin users",
    "onlySuperAdminsManageSuperAdmins": "Only Super Admins can manage Super Admin status",
    "passwordAlreadySet": "This user has already set a password. Use password reset instead.",
    "passwordComplexity": "Password does not meet requirements",
    "passwordMinLength": "Password must be at least {{count}} characters",
    "passwordNotSet": "This account has no password set",
    "passwordSetupRequired": "You must set your password before logging in",
    "profileNotFound": "Profile not found",
    "registrationFailed": "Registration failed",
    "registrationUnavailable": "Registration is not available",
    "resetPasswordFailed": "Failed to reset password",
    "revokeSessionFailed": "Could not revoke the session",
    "securityCheckFailed": "Security check failed. Please reload the page and try again.",
    "serverError": "Something went wrong on our side. Please try again.",
    "sessionNotFound": "Session not found",
    "tooManyLoginAttempts": "Too many login attempts. Try again in {{seconds}} seconds",
    "updateUserFailed": "Failed to update user",
    "userNotFound": "User not found",
    "usernameDerivedFromEmail": "The username is derived from the email when login is by email",
    "usernameExists": "Username already exists",
    "usernameRequired": "Username is required",
    "verificationFailed": "Verification failed",
    "verificationUnavailable": "Email verification is not available",
    "verifyInvitationFailed": "Could not verify the invitation",
    "accountDeactivated": "Account is deactivated",
    "accountLockedFor": "Account locked for {{seconds}} seconds",
    "invalidPassword": "Invalid password",
    "invalidPasswordLocked": "Invalid password – account locked for {{seconds}} seconds",
    "passwordPolicyDefault": "Password must contain uppercase, lowercase, number, and special character",
    "platformAccessDenied": "Access denied for this platform ({{platform}})",
    "sendVerificationFailed": "The verification email could not be sent"
  },
  "dataTable": {
    "clearFilters": "Clear filters",
    "columns": "Columns",
    "noResults": "No results.",
    "pagination": {
      "next": "Next",
      "pageOf": "Page {{page}} of {{pageCount}}",
      "perPage": "{{count}} / page",
      "previous": "Previous",
      "showing": "Showing {{from}} to {{to}} of {{total}} results"
    },
    "rowsSelected": "{{selected}} of {{total}} row(s) selected.",
    "searchPlaceholder": "Search...",
    "column": {
      "actions": "Actions",
      "createdAt": "Created",
      "isActive": "Status",
      "lastLoginAt": "Last Login",
      "name": "Name",
      "roles": "Roles",
      "username": "Username"
    }
  },
  "forgotPassword": {
    "backToLogin": "Back to login",
    "description": "Enter your email and we will send you a reset link.",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "sent": {
      "description": "If an account exists with this email, you will receive a reset link.",
      "title": "Check your email"
    },
    "submit": "Send Reset Link",
    "title": "Forgot Password"
  },
  "password": {
    "error": {
      "complexity": "Password does not meet requirements",
      "minLength": "Password must be at least {{count}} characters"
    },
    "requirement": {
      "complexity": "Meets complexity requirements",
      "minLength": "At least {{count}} characters"
    },
    "show": "Show password",
    "hide": "Hide password"
  },
  "register": {
    "button": "Create account",
    "button.loading": "Creating account...",
    "confirmPassword": {
      "label": "Confirm Password",
      "placeholder": "Confirm your password"
    },
    "description": "Enter your details to create your account",
    "email": {
      "label": "Email",
      "placeholder": "Enter your email"
    },
    "error": {
      "failed": "Registration failed. Please try again.",
      "invalidEmail": "Please enter a valid email address",
      "nameRequired": "Name is required",
      "passwordLength": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords do not match"
    },
    "hasAccount": "Already have an account?",
    "name": {
      "label": "Name",
      "placeholder": "Enter your name"
    },
    "password": {
      "label": "Password",
      "placeholder": "Enter your password"
    },
    "signIn": "Sign in",
    "success": "Registration successful! Please check your email to verify your account.",
    "title": "Create an account"
  },
  "resetPassword": {
    "confirmPassword": "Confirm Password",
    "description": "Enter your new password below.",
    "error": "Failed to reset password",
    "goToLogin": "Go to Login",
    "invalid": {
      "description": "This password reset link has expired or is invalid. Please request a new one.",
      "title": "Invalid or Expired Link"
    },
    "newPassword": "New Password",
    "passwordInvalid": "Password does not meet requirements",
    "passwordMismatch": "Passwords do not match",
    "requestNew": "Request New Link",
    "submit": "Reset Password",
    "success": "Password reset successfully",
    "success.description": "You will be redirected to login shortly.",
    "success.title": "Password Reset Successfully",
    "title": "Reset Password"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "This verification link is invalid or has expired.",
      "noToken": "No verification token provided",
      "title": "Verification Failed"
    },
    "goToLogin": "Go to Login",
    "needAccount": "Don't have an account?",
    "resend": {
      "button": "Resend Verification Email",
      "cancel": "Cancel",
      "email": {
        "label": "Email Address",
        "placeholder": "Enter your email"
      },
      "emailRequired": "Please enter your email",
      "sending": "Sending...",
      "submit": "Send",
      "success": "If your email is registered, you will receive a verification email."
    },
    "signUp": "Sign up",
    "success": {
      "description": "Your email has been verified successfully. You can now log in to your account.",
      "redirect": "Redirecting to login...",
      "title": "Email Verified!"
    }
  },
  "unsavedChanges": {
    "title": "Leave without saving?",
    "body": "Your changes will be lost.",
    "stay": "Stay",
    "leave": "Leave"
  },
  "richText": {
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strike": "Strikethrough",
    "heading": "Heading",
    "paragraph": "Paragraph",
    "bullets": "Bulleted list",
    "numbers": "Numbered list",
    "quote": "Quote"
  },
  "oktober": {
    "search": {
      "handbook": "Employee hub",
      "title": "Find anything",
      "placeholder": "Search tasks, clients, people and pages…",
      "pages": "Pages",
      "clients": "Clients",
      "myClients": "My clients",
      "tasks": "Tasks",
      "people": "People",
      "empty": "Nothing matches “{{query}}”",
      "move": "to move",
      "open": "to open",
      "close": "to close"
    },
    "sidebar": {
      "peopleOut": "{{count}} · {{out}} out",
      "daysLeft": "{{count}}d left",
      "findAnything": "Find anything",
      "company": "Company",
      "system": "System",
      "pod": "Pod {{name}}",
      "noPod": "No pod",
      "noTeam": "No team",
      "otherTeams": "Other",
      "collapse": "Collapse menu",
      "expand": "Expand menu",
      "home": "October OS home",
      "searchShortcut": "Search (Ctrl K)",
      "search": "Search",
      "findClient": "Find a client",
      "results": "Results",
      "clients": "Clients",
      "mine": "Mine",
      "all": "All",
      "noMatch": "No client matches “{{query}}”",
      "health": "Health {{value}}/5",
      "people": "People",
      "knowledge": "Knowledge"
    },
    "userMenu": {
      "language": "Language",
      "reset": "Reset sample data",
      "resetConfirm": "Throw away the changes made in this browser and start the sample data over?"
    },
    "viewingAs": {
      "label": "Viewing as",
      "hint": "Your login isn't linked to anyone on the team yet, so you're seeing someone else's work.",
      "clients": "Preview as client",
      "preview": "Preview",
      "myView": "My view",
      "team": "Team"
    },
    "splash": {
      "tagline": "Brand systems for the Figma plugin.",
      "hint": "v0.4 — local build · click to continue"
    },
    "auth": {
      "copyright": "© {{year}} Oktober. All rights reserved."
    },
    "loading": "Loading…",
    "notAvailable": "Not available until the backend is connected.",
    "actionFailed": "Something went wrong.",
    "errors": {
      "teamMissing": "That team no longer exists.",
      "podMissing": "That pod no longer exists.",
      "taskNotFound": "Task not found.",
      "titleRequired": "Title is required.",
      "commentEmpty": "Write a comment first.",
      "employeeNotFound": "Person not found.",
      "emailTaken": "Someone already uses this email.",
      "selfManager": "A person can't manage themselves.",
      "nameEmailRequired": "Name and email are required.",
      "clientNotFound": "Client not found.",
      "nameRequired": "Client name is required.",
      "leaveDates": "The end date is before the start date.",
      "leaveNotFound": "Leave request not found.",
      "templateNotFound": "Template not found.",
      "checklistItemNotFound": "Checklist item not found.",
      "leaveDecided": "That request has already been decided.",
      "leaveLocked": "That time off has already started and can no longer be cancelled.",
      "cycleName": "Give the cycle a name.",
      "cycleNotFound": "Review cycle not found.",
      "reviewNotFound": "Review not found.",
      "reviewLocked": "This review is not yours to change right now.",
      "reviewIncomplete": "Rate every value and skill first.",
      "leave": {
        "order": "The last day is before the first.",
        "noDays": "Those dates are only weekends or company holidays.",
        "overlap": "You already have time off on some of these days.",
        "balance": "Not enough vacation days left.",
        "blackout": "No time off for delivery roles from 15 to 30 November.",
        "q4Cap": "That goes past the 5 days allowed between 15 October and 15 December.",
        "q4Streak": "In Q4 it is 2 days in a row at most."
      },
      "commentNotFound": "That comment is gone.",
      "reviewClosed": "This email is not waiting for review any more.",
      "changesEmpty": "Say what should change, or leave a comment on the design.",
      "stage": {
        "client": "Choose the client before moving on.",
        "sendAt": "Set the send date before moving on.",
        "brief": "Write the brief before it goes to copywriting.",
        "copy": "Add the copy (a copy doc or written here) before it goes to design.",
        "design": "Link the Figma design before it goes to review.",
        "klaviyo": "Link the Klaviyo campaign before QA."
      }
    }
  },
  "vocab": {
    "stage": {
      "BACKLOG": "Backlog",
      "BRIEFING": "Briefing",
      "COPYWRITING": "Copywriting",
      "DESIGN": "Design",
      "INTERNAL_REVIEW": "Internal review",
      "CLIENT_REVIEW": "Client review",
      "IMPLEMENTATION": "Implementation",
      "QA_SCHEDULE": "QA & schedule",
      "SCHEDULED": "Scheduled",
      "SENT": "Sent"
    },
    "assetType": {
      "EMAIL_CAMPAIGN": "Email Campaign",
      "EMAIL_FLOW": "Email Flow",
      "SMS_CAMPAIGN": "SMS Campaign",
      "ACCOUNT_MANAGEMENT": "Account Management",
      "LIST_GROWTH": "List Growth",
      "AD_CREATIVE": "Ad Creative",
      "DESIGN_ONLY": "Design Only",
      "AB_TEST": "A/B test",
      "OTHER": "Other"
    },
    "assetTypeShort": {
      "EMAIL_CAMPAIGN": "Campaign",
      "EMAIL_FLOW": "Flow",
      "SMS_CAMPAIGN": "SMS",
      "ACCOUNT_MANAGEMENT": "AM",
      "LIST_GROWTH": "List growth",
      "AD_CREATIVE": "Ad",
      "DESIGN_ONLY": "Design only",
      "AB_TEST": "A/B",
      "OTHER": "Other"
    },
    "pillar": {
      "PRODUCT": "Product",
      "CONTENT": "Content",
      "LOYALTY": "Loyalty",
      "PROMOTION": "Promotion",
      "DATA": "Data",
      "WINBACK": "Winback"
    },
    "priority": {
      "URGENT": "Urgent",
      "HIGH": "High",
      "NORMAL": "Normal",
      "LOW": "Low"
    },
    "taskRole": {
      "accountManager": "Account manager",
      "copywriter": "Copywriter",
      "designer": "Designer",
      "implementor": "Implementor"
    },
    "taskRoleShort": {
      "accountManager": "AM",
      "copywriter": "Copy",
      "designer": "Design",
      "implementor": "Impl"
    },
    "employeeRole": {
      "LEADERSHIP": "Leadership",
      "TEAM_LEAD": "Team lead",
      "RETENTION_MANAGER": "Retention manager",
      "DESIGNER": "Designer",
      "KLAVIYO_TECH": "Klaviyo tech",
      "OPS": "Ops",
      "OTHER": "Other"
    },
    "employeeStatus": {
      "ONBOARDING": "Onboarding",
      "ACTIVE": "Active",
      "OFFBOARDED": "Offboarded"
    },
    "clientStatus": {
      "ONBOARDING": "Onboarding",
      "ACTIVE": "Active",
      "OFFBOARDING": "Offboarding",
      "INACTIVE": "Inactive"
    },
    "leaveType": {
      "VACATION": "Vacation",
      "SICK": "Sick leave",
      "OTHER": "Other"
    },
    "leaveStatus": {
      "PENDING": "Pending",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "CANCELLED": "Cancelled"
    },
    "onboardingTarget": {
      "EMPLOYEE": "Employee",
      "CLIENT": "Client"
    },
    "assetKind": {
      "LOGO": "Logo",
      "FONT": "Font",
      "IMAGE": "Image"
    }
  },
  "pipeline": {
    "eyebrow": "Campaign pipeline",
    "title": "Pipeline",
    "viewBoard": "Board",
    "viewList": "List",
    "viewCalendar": "Calendar",
    "newTaskPlaceholder": "New task title…",
    "clientPlaceholder": "Client…",
    "add": "Add",
    "searchPlaceholder": "Search tasks or clients",
    "myWork": "My work",
    "mineTitle": "Tasks where you hold any role",
    "mineUnlinked": "Your login isn't linked to a team member yet",
    "allTeams": "All teams",
    "allPods": "All pods",
    "allClients": "All clients",
    "anyone": "Anyone",
    "allTypes": "All types",
    "clear": "Clear",
    "loading": "Loading…",
    "taskCount_one": "{{count}} task",
    "taskCount_other": "{{count}} tasks",
    "emailsCount_one": "{{count}} email",
    "emailsCount_other": "{{count}} emails",
    "totalEmailsTitle": "Total emails in this column",
    "showAll": "Show all {{count}}",
    "blocked": "Blocked",
    "waitingOnClient": "Waiting on client",
    "sendDate": "Send date",
    "noSendDate": "No send date",
    "colSend": "Send",
    "colClient": "Client",
    "colTask": "Task",
    "colType": "Type",
    "colStage": "Stage",
    "colPeople": "People",
    "workTabs": "My tasks",
    "tabNow": "Now",
    "tabUpcoming": "Upcoming",
    "tabFinished": "Finished",
    "colName": "Name",
    "colMyDeadline": "My deadline",
    "colRoleDeadline": "{{role}} deadline",
    "viewLabel": "View",
    "colStageDeadline": "Stage deadline",
    "comments": "Comments",
    "noMatch": "No tasks match these filters.",
    "focus": {
      "clear": "Show everything again",
      "dueToday": "Due today",
      "sendingToday": "Sending today",
      "lateMine": "Past your deadline",
      "late": "Overdue",
      "waiting": "Waiting on clients"
    }
  },
  "calendar": {
    "eyebrow": "Send calendar",
    "title": "Calendar",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "today": "Today",
    "internal": "Internal",
    "unscheduled_one": "{{count}} task without a send date (see List)",
    "unscheduled_other": "{{count}} tasks without a send date (see List)",
    "more": "+{{count}} more",
    "less": "Show less"
  },
  "myWork": {
    "eyebrow": "Your tasks",
    "title": "Workspace",
    "noPerson": "There is no team data to show yet.",
    "morning": "Good morning, {{name}}",
    "afternoon": "Good afternoon, {{name}}",
    "evening": "Good evening, {{name}}",
    "onDesk": "On your desk now: {{n}}"
  },
  "task": {
    "viewers": {
      "onlyYou": "Only you are here",
      "withYou": "You and {{names}} are here"
    },
    "stageView": {
      "copy": {
        "subject": "Subject line, 50 characters or fewer",
        "preview": "Preview text written",
        "cta": "A clear CTA",
        "proofread": "Proofread: spelling, tone, brand voice",
        "tags": "Personalisation tags checked",
        "doc": "Final copy is in the master doc",
        "title": "Write the copy",
        "import": "Start from the master doc",
        "subjectLabel": "Subject line",
        "previewLabel": "Preview text",
        "senderLabel": "Sender name",
        "sectionName": "Section name",
        "up": "Move up",
        "down": "Move down",
        "remove": "Remove section",
        "sectionPh": "H1: …\nBody: …\nCTA: …",
        "addSection": "Add a section",
        "masterDoc": "Master doc"
      },
      "briefing": {
        "messageLabel": "Key message & offer",
        "openClient": "Open client & brand kit",
        "objective": "Objective written",
        "audience": "Audience defined",
        "message": "Key message and offer",
        "doc": "Copy doc created and linked",
        "shared": "Brief walked through with the copywriter",
        "title": "Write the brief",
        "hint": "Everything the copywriter needs to start without asking.",
        "audiencePh": "Segments to include and exclude",
        "messagePh": "The one thing the reader should take away, and the offer if there is one",
        "docTitle": "Copy doc",
        "docHint": "Link the email's heading in the master doc so everyone lands on it.",
        "noNotes": "No client notes yet."
      },
      "notSet": "Not filled in",
      "design": {
        "copyTitle": "Copy to design",
        "noCopy": "No copy yet: it appears here once the copywriter writes it.",
        "figma": "Figma frame linked",
        "copy": "Uses the latest copy",
        "brand": "Brand colours, fonts and components",
        "mobile": "Checked at mobile width",
        "images": "Images exported and compressed",
        "notes": "Links and alt texts noted for Klaviyo",
        "brandTitle": "Brand",
        "copyTab": "Copy",
        "designTab": "Design",
        "brandKit": "Brand kit",
        "noKit": "No brand kit for {{name}} yet",
        "noKitText": "Colours, fonts and the logo show here once they're in the brand kit.",
        "setUpKit": "Set up the brand kit",
        "copyHex": "Copy {{hex}}",
        "headings": "for headings",
        "body": "for text"
      },
      "backlog": {
        "client": "Client",
        "send": "Send date",
        "am": "Account manager assigned",
        "copywriter": "Copywriter assigned",
        "designer": "Designer assigned",
        "implementor": "Klaviyo tech assigned",
        "deadlines": "Internal deadlines",
        "deadlinesHint": "Copy, design and Klaviyo",
        "title": "Plan this email",
        "missing": "{{n}} things to settle before briefing. Fill them in under Details and the people above.",
        "ready": "Everything's in place: it can move to briefing.",
        "objectivePh": "What should this email achieve?",
        "stillMissing": "Still missing before briefing"
      },
      "review": {
        "feedbackPh": "What needs to change? It's posted as a comment.",
        "backTo": "Back to {{stage}}",
        "brief": "Matches the brief",
        "inbox": "Subject line and preview text are right",
        "typos": "No typos, tone fits the brand",
        "links": "CTAs and links point where they should",
        "design": "Design matches the copy and the brand",
        "mobile": "Works on mobile",
        "decision": "Decision",
        "approve": "Approve: send to {{stage}}",
        "changes": "Or send it back with notes",
        "openInternal_one": "{{count}} open comment: resolve it, or send it back with notes",
        "openInternal_other": "{{count}} open comments: resolve them, or send it back with notes",
        "clear": "No open comments. Ready for the client?",
        "sendTo": "Send back to",
        "sendBack": "Send it back with notes"
      },
      "client": {
        "msgHello": "Hi! The next email is ready for your review:",
        "msgDesign": "Design",
        "msgCopy": "Copy",
        "msgThanks": "Let us know if you'd like any changes.",
        "title": "With the client",
        "hint": "Send the client the design and copy, then record their answer here.",
        "waiting": "Days waiting on the client: {{n}}",
        "copyMessage": "Copy message for the client",
        "answer": "The client's answer",
        "feedback": "Client feedback",
        "approved": "Client approved: on to {{stage}}",
        "changes": "Changes requested",
        "msgLink": "Review and comment here",
        "changesBy": "{{name}} asked for changes",
        "approvedBy": "{{name}} approved it",
        "waitingFor_one": "Waiting for the client · {{count}} day",
        "waitingFor_other": "Waiting for the client · {{count}} days",
        "statusHint": "The client comments on the design and answers on their review page.",
        "copyLink": "Copy review link",
        "clientView": "Client's view",
        "sendAgain": "Send the new version",
        "send": "Mark as sent today",
        "answerHint": "If they answered by email or call, note it here.",
        "openComments_one": "{{count}} open comment, {{client}} from the client",
        "openComments_other": "{{count}} open comments, {{client}} from the client"
      },
      "checklist": "Checklist",
      "autoCheck": "Ticks itself when this is filled in",
      "copyText": "Copy",
      "copied": "Copied",
      "build": {
        "sheet": "Build sheet",
        "sheetHint": "Everything to paste into Klaviyo, from the copy and the details.",
        "links": "Links in the copy",
        "klaviyo": "Klaviyo campaign",
        "openKlaviyo": "Open",
        "klaviyoUrl": "Campaign link",
        "template": "Template built from the Figma frame",
        "inbox": "Subject, preview text and sender set",
        "segments": "Segments and exclusions set",
        "utm": "Links and UTMs checked",
        "alt": "Alt text on every image",
        "test": "Test email sent to the team",
        "campaign": "Campaign linked here"
      },
      "qa": {
        "inbox": "Test lands in the inbox, not spam",
        "desktop": "Looks right on desktop",
        "mobile": "Looks right on mobile and in dark mode",
        "links": "Every link opens the right page",
        "tags": "Personalisation shows, with fallbacks",
        "footer": "Unsubscribe and footer present",
        "time": "Send time and time zone confirmed",
        "scheduled": "Scheduled in Klaviyo",
        "schedule": "Schedule",
        "sendsAt": "Sends {{date}}",
        "noDate": "No send date yet: set it under Details.",
        "markScheduled": "Mark as {{stage}}"
      },
      "scheduled": {
        "due": "Send time has passed",
        "inDays": "Sends in {{n}} days",
        "inHours": "Sends in {{n}} h"
      },
      "sent": {
        "title": "Results",
        "hint": "From Klaviyo, a few days after sending.",
        "open": "Open rate %",
        "click": "Click rate %",
        "revenue": "Revenue",
        "learnings": "What to keep or change next time"
      },
      "waitingClient": "Waiting on the client",
      "for": "Owner: {{role}}",
      "due": "Due {{date}}",
      "modeLabel": "Work area",
      "focus": "Stage view",
      "all": "Everything"
    },
    "back": "Back",
    "loading": "Loading…",
    "missing": "This task doesn't exist anymore.",
    "internal": "Internal",
    "sends": "Sends {{date}}",
    "close": "Close task",
    "blocked": "Blocked",
    "markBlocked": "Mark blocked",
    "moveTo": "Move to {{stage}}",
    "deleteConfirm": "Delete this task?",
    "delete": "Delete task",
    "openInClickup": "Open in ClickUp",
    "layout": {
      "page": "Page",
      "modal": "Pop-up",
      "drawer": "Side",
      "openAs": "Open tasks as",
      "pageTitle": "Open tasks as a page",
      "modalTitle": "Open tasks as a pop-up",
      "drawerTitle": "Open tasks as a side panel"
    },
    "people": {
      "nobody": "nobody",
      "unassign": "Nobody"
    },
    "details": {
      "title": "Details",
      "send": "Send",
      "client": "Client",
      "noPillar": "No pillar",
      "type": "Type",
      "pillar": "Pillar",
      "emails": "Emails",
      "priority": "Priority"
    },
    "deadlines": {
      "title": "Internal deadlines",
      "copy": "Copy",
      "design": "Design"
    },
    "brief": {
      "title": "Brief",
      "audience": "Audience",
      "objective": "Objective",
      "full": "Full brief",
      "empty": "empty",
      "placeholder": "Add details…"
    },
    "links": {
      "title": "Links",
      "copyDoc": "Copy doc",
      "figmaFrame": "Figma frame",
      "paste": "Paste a link…",
      "open": "Open {{what}}",
      "edit": "Change {{what}}"
    },
    "comments": {
      "title": "Comments",
      "placeholder": "Write a comment…",
      "empty": "No comments yet",
      "send": "Send comment"
    },
    "history": {
      "title": "History",
      "system": "System"
    },
    "timeline": {
      "label": "Task stage",
      "current": "Current stage: {{stage}}",
      "moveTo": "Move to {{stage}}",
      "needs": "Needs {{list}} first",
      "blocked": "Can't move to {{stage}} yet: add {{list}} first."
    },
    "activity": {
      "created": "created the task",
      "imported": "imported from ClickUp",
      "stage_changed": "moved {{from}} → {{to}}",
      "priority_changed": "set priority to {{priority}}",
      "assigned": "set {{role}} to {{person}}",
      "assigned_cleared": "cleared {{role}}",
      "assignee": "assignee",
      "someone": "someone",
      "send_changed": "set send date to {{date}}",
      "send_cleared": "cleared the send date",
      "blocked": "marked it blocked",
      "unblocked": "unblocked it",
      "commented": "commented",
      "edited": "edited the task",
      "other": "Updated"
    },
    "copy": {
      "title": "Copy",
      "sample": "Sample",
      "refresh": "Refresh",
      "refreshUnavailable": "Available once Google Docs is connected",
      "openDoc": "Open doc",
      "reading": "Reading the copy doc…",
      "noLink": "No copy linked yet. Paste the Google Doc link to the email's heading:",
      "hintGuess": "The link doesn't point at a heading, so this section was matched by send date and title. Check it's the right email.",
      "hintNone": "Couldn't find this email's section — showing the whole tab. Link the task to the email's heading to narrow it down.",
      "empty": "This section of the doc is empty.",
      "section": "Section",
      "errorTitle": "Couldn't read the copy",
      "reason": {
        "no-link": "No copy is linked to this task yet.",
        "bad-link": "The copy link isn't a Google Doc link.",
        "not-configured": "Google Docs isn't connected yet.",
        "api-disabled": "The Google Docs API is disabled for this project.",
        "no-access": "No access to this Google Doc.",
        "heading-missing": "The heading in the link wasn't found in the doc.",
        "error": "Something went wrong reading the doc."
      }
    },
    "design": {
      "title": "Design",
      "previewAs": "Preview as",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "rerender": "Re-render",
      "rerendering": "Rendering…",
      "renderedAt": "Rendered {{date}}",
      "openInFigma": "Open in Figma",
      "noDesign": "No design yet. Paste the link to the email's Figma frame:",
      "iframeTitle": "Figma design",
      "notFigma": "The design link isn't a Figma link, so it can't be embedded.",
      "rendering": "Rendering the frame from Figma…",
      "errorTitle": "Couldn't render the design",
      "unreachable": "The preview service didn't answer. Try again in a moment.",
      "notConnected": "Preview available once connected",
      "searchMail": "Search mail",
      "inbox": "Inbox",
      "toMe": "to me",
      "imageAlt": "{{subject}} — email design"
    },
    "gate": {
      "client": "a client",
      "sendAt": "a send date",
      "brief": "the brief",
      "copy": "the copy",
      "design": "the Figma link",
      "klaviyo": "the Klaviyo campaign link",
      "note": "Add {{list}} to move on.",
      "show": "Show me where"
    }
  },
  "dashboard": {
    "hint": {
      "onDesk": "Your turn now",
      "dueToday": "Your deadline is today",
      "overdueMine": "Past your deadline",
      "upcoming": "Still with others",
      "waiting": "In client review",
      "sendingToday": "Your clients' sends",
      "overdue": "Past the send date",
      "watch": "Low health, leaving or quiet"
    },
    "personal": {
      "intro": "Here's what's on your desk today.",
      "clear": "Your desk is clear — nothing is waiting on you.",
      "noDate": "No date",
      "kpi": {
        "onDesk": "On your desk",
        "dueToday": "Due today",
        "overdue": "Overdue",
        "upcoming": "Coming your way",
        "waiting": "Waiting on clients",
        "sendingToday": "Sending today"
      },
      "desk": {
        "title": "On your desk",
        "all": "Workspace →",
        "empty": "Nothing on your desk. Enjoy it."
      },
      "upcoming": {
        "title": "Coming your way",
        "empty": "Nothing headed your way yet.",
        "all": "All →"
      },
      "clients": {
        "title": "My clients",
        "empty": "No clients assigned to you yet."
      }
    },
    "there": "there",
    "greeting": {
      "morning": "Good morning, {{name}}",
      "afternoon": "Good afternoon, {{name}}",
      "evening": "Good evening, {{name}}"
    },
    "intro": {
      "nothingToday": "Nothing goes out today.",
      "emails_one": "{{count}} email goes out today across {{sends}}",
      "emails_other": "{{count}} emails go out today across {{sends}}",
      "sends_one": "{{count}} send",
      "sends_other": "{{count}} sends",
      "notReady": " — {{count}} not scheduled yet.",
      "allScheduled": ", all scheduled.",
      "nothingOnYou": "Nothing is waiting on you.",
      "onYou_one": "{{count}} task is waiting on you.",
      "onYou_other": "{{count}} tasks are waiting on you."
    },
    "kpi": {
      "emailsToday": "Emails today",
      "emailsWeek": "Emails next 7 days",
      "waiting": "Waiting on clients",
      "overdue": "Overdue tasks",
      "watch": "Accounts to watch"
    },
    "goingOut": {
      "title": "Going out",
      "calendar": "Calendar →",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nothingPlanned": "nothing planned",
      "notScheduled": "{{open}} of {{total}} not scheduled yet",
      "scheduled": "{{count}} scheduled"
    },
    "internal": "Internal",
    "moreCount": "+{{count}} more",
    "pods": {
      "title": "Pods",
      "structure": "Structure →",
      "pod": "Pod",
      "clients": "Clients",
      "open": "Open",
      "overdue": "Overdue",
      "waiting": "Waiting"
    },
    "myWork": {
      "title": "My work",
      "all": "All →",
      "noPersonBefore": "Your login isn't linked to a team member yet — add yourself on the",
      "team": "Team",
      "noPersonAfter": "page with the same email.",
      "empty": "Nothing open. Enjoy it.",
      "onYou": "Waiting on you",
      "elsewhere": "In someone else's hands"
    },
    "watch": {
      "title": "Accounts to watch",
      "healthy": "Every account looks healthy.",
      "offboarding": "Offboarding",
      "health": "Health {{value}}/5",
      "nothingSending": "Nothing sending in 14 days"
    },
    "out": {
      "title": "Out today",
      "everyoneIn": "Everyone's in.",
      "until": "until {{date}}",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "calendar": "Who’s away →"
    },
    "onboarding": {
      "title": "Onboarding",
      "hr": "HR →"
    },
    "people": {
      "title": "Time off & reviews",
      "open": "HR →",
      "daysLeft": "vacation days left",
      "next": "next time off",
      "nothing": "nothing booked",
      "reviews": "Reviews waiting on you: {{count}}",
      "vacation": "Vacation",
      "sick": "Paid sick days",
      "nothingTitle": "No time off booked",
      "nothingHint": "A week or more needs about 8 weeks’ notice.",
      "yourReview": "Your {{cycle}} review",
      "due": "Due {{date}}"
    },
    "away": {
      "back": "back {{date}}",
      "title": "Away this week",
      "none": "Everyone is in this week.",
      "today": "Out today",
      "later": "Later this week"
    },
    "desk": {
      "late": "Overdue",
      "today": "Due today",
      "week": "Later this week",
      "later": "Next week and later"
    }
  },
  "hub": {
    "backToTop": "Back to top",
    "topics": "Topics",
    "resultsFor": "{{n}} results for “{{query}}”",
    "clear": "Clear",
    "groupText": {
      "onboarding": "Your first days: who we are, the tools and the channels.",
      "policies": "Time off, sick leave, sync hours and the Q4 rules.",
      "money": "Invoices, bonuses and referrals.",
      "work": "How the team is set up, Slack and our meetings.",
      "events": "Getting together as a team."
    },
    "title": "Employee hub",
    "empty": "The handbook hasn't been imported yet.",
    "search": "Search the hub…",
    "home": "Home",
    "welcome": "Everything about working at OKTOBER",
    "intro": "Time off, pay, how we work together and how to get started, in one place.",
    "synced": "Synced from ClickUp on {{date}}",
    "openClickUp": "Open in ClickUp",
    "startHere": "Start here",
    "startHereName": "Start here, {{name}}",
    "glance": "At a glance",
    "updated": "Updated {{date}}",
    "readTime": "{{n}} min read",
    "onThisPage": "On this page",
    "previous": "Previous",
    "next": "Next",
    "noResults": "Nothing in the hub matches “{{query}}”",
    "group": {
      "onboarding": "Onboarding",
      "policies": "Time off & policies",
      "money": "Pay & invoicing",
      "work": "How we work",
      "events": "Events"
    },
    "action": {
      "ptoTitle": "{{n}} vacation days left",
      "ptoTitleNoMe": "Time off in the OS",
      "ptoText": "Requests are checked against these rules as you fill them in and go straight to whoever approves yours.",
      "ptoOpen": "Time off and team calendar",
      "sickTitle": "{{n}} of {{total}} paid sick days left",
      "sickTitleNoMe": "Sick leave in the OS",
      "sickText": "Report it on the day: it is approved straight away and your team sees you are out.",
      "reportSick": "Report sick today",
      "orgTitle": "The live org chart",
      "orgText": "Teams, pods, leads and clients as they are today, and every person’s profile one click away.",
      "orgOpen": "Open the org chart"
    }
  },
  "hr": {
    "eyebrow": "People",
    "title": "HR",
    "tab": {
      "hub": "Employee hub",
      "leave": "Time off",
      "org": "Org chart",
      "onboarding": "Onboarding",
      "overview": "Overview",
      "approvals": "Approvals",
      "reviews": "Reviews"
    },
    "leave": {
      "teamMember": "— team member —",
      "from": "From",
      "to": "To",
      "request": "Request",
      "empty": "No requests this year.",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "approve": "Approve",
      "reject": "Reject",
      "balance": "Vacation balance",
      "left": "{{remaining}}/{{allowance}} left",
      "allowanceNote": "Default 20 days a year — per-person allowances can be changed on their profile."
    },
    "org": {
      "teams": "Teams",
      "pods": "Pods",
      "people": "People",
      "clients": "Clients",
      "teamMeta": "{{pods}} pods · {{people}} people · {{clients}} clients",
      "teamLead": "Team lead",
      "designLead": "Design lead",
      "podLead": "Pod lead",
      "retention": "Retention",
      "design": "Design",
      "others": "Others",
      "emptyPod": "No one else in this pod yet",
      "shared": "Across the team",
      "noPod": "Not in a pod yet",
      "techs": "Klaviyo techs",
      "techsHint": "Teams from the tasks they implement",
      "floating": "Not in a team",
      "floatingHint": "Floating designers, leadership and ops",
      "empty": "No team members yet.",
      "note": "The hierarchy comes from the \"Manager / mentor\" field on each person's profile."
    },
    "onb": {
      "templates": "Templates",
      "new": "New",
      "namePlaceholder": "Template name (e.g. New designer)",
      "forEmployees": "For team members",
      "forClients": "For clients",
      "itemsPlaceholder": "One item per line:\nContract signed\nLaptop handed over\nAccounts created",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "items_one": "{{count}} item",
      "items_other": "{{count}} items",
      "runs_one": "{{count}} run",
      "runs_other": "{{count}} runs",
      "pickEmployee": "— team member —",
      "pickClient": "— client —",
      "start": "Start",
      "active": "Active onboardings",
      "empty": "No onboardings running."
    },
    "requestTimeOff": "Request time off",
    "noPerson": "Your login is not linked to a team member yet.",
    "cancel": "Cancel",
    "cancelConfirm": "Cancel this request?",
    "cancelRequest": "Cancel request",
    "approvals": {
      "waiting": "Waiting for your decision",
      "mine": "Routed to me",
      "all": "All requests",
      "none": "Nothing waiting for you. Requests routed to you land here.",
      "decided": "Recently decided",
      "asked": "Asked {{date}}",
      "after_one": "{{count}} day left after this",
      "after_other": "{{count}} days left after this",
      "alsoOut": "Also away then: {{names}}",
      "nobodyOut": "Nobody else in the pod or team is away then",
      "note": "Note for {{name}} (optional)",
      "decline": "Decline",
      "approve": "Approve"
    },
    "overview": {
      "toApprove_one": "{{count}} time-off request to decide",
      "toApprove_other": "{{count}} time-off requests to decide",
      "selfReview": "Write your self-review",
      "ackReview": "Read and acknowledge your review",
      "due": "{{cycle}} · due {{date}}",
      "leadReviews_one": "{{count}} review to write",
      "leadReviews_other": "{{count}} reviews to write",
      "yourTimeOff": "Your time off",
      "allTimeOff": "All time off",
      "vacationLeft": "vacation days left of {{n}}",
      "sickLeft": "paid sick days left",
      "inDays_one": "in {{count}} day",
      "inDays_other": "in {{count}} days",
      "nothingBooked": "Nothing booked yet. Plan ahead: longer breaks need eight weeks’ notice.",
      "waiting": "Waiting for you",
      "allClearLead": "All clear: no requests to decide and no reviews to write.",
      "allClear": "All clear. Nothing needs you here right now.",
      "away": "Away this week",
      "calendar": "Calendar",
      "nobodyAway": "Everyone is in this week.",
      "today": "Out today",
      "more": "+{{n}} more",
      "reviews": "Performance reviews",
      "open": "Open",
      "noCycle": "No review cycle is open. Leads start one from Reviews.",
      "handbook": "From the handbook",
      "hub": "Employee hub",
      "policy": "{{days}} vacation days a year, {{sick}} paid sick days. Requests go to your lead; sick days are approved right away."
    },
    "links": {
      "pto": "Paid time off",
      "sick": "Sick leave",
      "hours": "Sync hours",
      "q4": "Q4 and overwork"
    },
    "rules": {
      "order": "The last day is before the first.",
      "noDays": "Those dates are only weekends or company holidays.",
      "overlap": "You already have time off on some of these days.",
      "balance": "That is more than the {{n}} days you have left.",
      "blackout": "No time off for delivery roles from 15 to 30 November.",
      "q4Cap": "Between 15 October and 15 December it is 5 days at most; you have {{n}} left.",
      "q4Streak": "In Q4 it is 2 days in a row at most.",
      "notice": "Less than a week ahead: the handbook asks for at least one.",
      "longNotice": "For a week or more, try to ask 8 weeks ahead.",
      "talkToLead": "More than 10 days: talk it through with your pod lead too.",
      "sickFuture": "Sick leave is reported on the day you are sick.",
      "sickLate": "Sick days reported after the first day are not paid.",
      "sickUnpaid": "{{n}} of these days go past the 5 paid sick days and come off your invoice.",
      "title": "The rules in short",
      "short1": "30 personal days a year, plus 25–26 December and 1 January off for everyone.",
      "short2": "Ask at least a week ahead; for a week or more, about 8 weeks ahead.",
      "short3": "Sick? Report it on the day. 5 paid sick days a year.",
      "short4": "Q4: nothing 15–30 November, 5 days at most from 15 October to 15 December, 2 in a row.",
      "short5": "Days reset on 1 January and do not roll over.",
      "linkPto": "Paid time off",
      "linkSick": "Paid sick leave"
    },
    "request": {
      "title": "Request time off",
      "type": "Type",
      "from": "First day",
      "to": "Last day",
      "note": "Note (optional)",
      "sickHint": "Roughly how long you expect to be out",
      "noteHint": "Anything your approver should know",
      "days_one": "{{count}} workday",
      "days_other": "{{count}} workdays",
      "left_one": "{{count}} day left after this",
      "left_other": "{{count}} days left after this",
      "sickLeft": "{{n}} of {{total}} paid sick days left",
      "sickRoute": "Approved straight away. Tell your team lead and pod today, and hand over anything client-facing.",
      "route": "Goes to {{name}} for approval, usually within 24 hours.",
      "routeAdmin": "Goes to HR for approval.",
      "rules": "Time-off rules",
      "sendSick": "Report sick",
      "send": "Send request",
      "ctaHint": "Vacation, sick day or other leave"
    },
    "line": {
      "with": "with {{name}}"
    },
    "balance": {
      "vacation": "Vacation",
      "vacationHint": "{{used}} taken · {{pending}} waiting for approval",
      "sick": "Paid sick days",
      "sickHint": "Report on the day; from the 6th day it is unpaid",
      "next": "Next time off",
      "nothingPlanned": "Nothing planned yet"
    },
    "mine": {
      "title": "My requests",
      "empty": "No requests this year yet.",
      "upcoming": "Coming up",
      "past": "Earlier this year"
    },
    "calendar": {
      "title": "Who's away",
      "myTeam": "My team",
      "everyone": "Everyone",
      "awayOnly": "Only who is away",
      "nobody": "Nobody is away this month.",
      "holiday": "Company holiday"
    },
    "addPerson": {
      "button": "Add person",
      "title": "Add a person",
      "text": "Next you set their role, level, team and pod on their profile.",
      "name": "Full name",
      "email": "Work email",
      "save": "Add and open profile"
    },
    "head": {
      "overview": "Overview",
      "overviewText": "Your time off, what waits for you and who’s away this week.",
      "timeOff": "Time off",
      "timeOffText": "Your balance, your requests and the team’s calendar.",
      "approvals": "Approvals",
      "approvalsText": "Time-off requests routed to you, with the rules checked.",
      "reviews": "Performance reviews",
      "reviewsText": "Self-reviews, lead reviews and goals, one cycle at a time.",
      "org": "Org chart",
      "orgText": "Teams, pods, leads and the clients they look after.",
      "hub": "Employee hub",
      "hubText": "The People Handbook: how we work, time off, pay and the rest."
    }
  },
  "clients": {
    "assetUnavailable": "File not available until storage is connected",
    "cancel": "Cancel",
    "create": "Create",
    "eyebrow": "Repository",
    "title": "Clients",
    "newClient": "New client",
    "searchPlaceholder": "Search clients…  ( / )",
    "namePlaceholder": "Client name (e.g. Maison Hatch)",
    "empty": {
      "title": "No clients yet",
      "body": "Create a client to store its logo, brand guidelines, fonts, and imagery in one place."
    },
    "noMatch": "No clients match “{{query}}”.",
    "count_one": "{{count}} client",
    "count_other": "{{count}} clients",
    "colorsCount_one": "{{count}} color",
    "colorsCount_other": "{{count}} colors",
    "fontsCount_one": "{{count}} font",
    "fontsCount_other": "{{count}} fonts",
    "imagesCount_one": "{{count}} image",
    "imagesCount_other": "{{count}} images",
    "scaleLabel": "{{n}} of {{max}}",
    "tabs": {
      "overview": "Overview",
      "pipeline": "Pipeline",
      "calendar": "Calendar",
      "team": "Team",
      "onboarding": "Onboarding",
      "brand": "Brand kit"
    },
    "detail": {
      "allClients": "← All clients",
      "notFound": "Client not found.",
      "podLead": "Pod lead: {{name}}",
      "noPod": "{{team}} · no pod",
      "noTeam": "Not placed in a team",
      "health": "Health",
      "nps": "NPS",
      "clientSince": "Client since {{date}}",
      "newTask": "New task",
      "moreActions": "More actions",
      "rename": "Rename client",
      "renamePrompt": "Client name",
      "openClickUp": "Open in ClickUp",
      "delete": "Delete client",
      "deleteConfirm": "Delete client \"{{name}}\"? Its tasks stay, but lose their client.",
      "clients": "Clients"
    },
    "overview": {
      "openTasks": "Open tasks",
      "waitingOnClient": "Waiting on client",
      "overdue": "Overdue",
      "emailsNext7": "Emails next 7 days",
      "emailsSent30": "Emails sent, 30 days",
      "needsAttention": "Needs attention",
      "allClear": "All clear — nothing blocked, late or waiting.",
      "goingOut": "Going out — next 14 days",
      "nothingScheduled": "Nothing scheduled to send in the next two weeks.",
      "pipeline": "Pipeline",
      "people": "People on this client",
      "noOneAssigned": "No one assigned yet.",
      "podLead": "Pod lead",
      "podMember": "Pod",
      "assigned": "Assigned",
      "recentActivity": "Recent activity",
      "noActivity": "No changes in October OS yet.",
      "system": "System",
      "onTask": "on",
      "reason": {
        "blocked": "Blocked",
        "overdue": "Overdue",
        "waiting": "Waiting on client",
        "atRisk": "At risk",
        "noDate": "No send date"
      },
      "noSendDate": "no send date",
      "hasIt": "{{name}} has it",
      "allScheduled": "all scheduled",
      "notScheduled_one": "{{count}} not scheduled yet",
      "notScheduled_other": "{{count}} not scheduled yet",
      "noOpenTasks": "No open tasks.",
      "openPipeline": "Open the pipeline",
      "emailsPerWeek": "Emails per week",
      "sent": "sent",
      "planned": "planned",
      "weekTitle_one": "Week of {{date}}: {{count}} email",
      "weekTitle_other": "Week of {{date}}: {{count}} emails",
      "account": "Account",
      "status": "Status",
      "pod": "Pod",
      "none": "— none —",
      "health": "Health",
      "clientSince": "Client since",
      "contractEnd": "Contract end",
      "scope": "Scope",
      "notes": "Notes",
      "scopePlaceholder": "What we do for them (e.g. 12 campaigns/mo + flows)",
      "notesPlaceholder": "Anything the team should know about this client…",
      "openHint": "In the pipeline now",
      "waitingHint": "In client review",
      "overdueHint": "Past their deadline",
      "next7Hint": "Planned to go out",
      "sent30Hint": "Already out",
      "calendar": "Calendar →",
      "openPipelineLink": "Pipeline →",
      "all": "All",
      "inPipeline": "See them in the pipeline →",
      "showAll": "Show all {{count}}",
      "teamLink": "Team →"
    },
    "team": {
      "podTitle": "{{team}} · Pod {{pod}}",
      "pod": "Pod",
      "structure": "Structure",
      "noPod": "Not in a pod yet — pick one under Account on the Overview tab.",
      "alsoAssigned": "Also assigned",
      "nobodyOutside": "Nobody outside the pod.",
      "remove": "Remove",
      "assignAria": "Assign someone to this client",
      "assignPlaceholder": "+ Assign someone…",
      "workedOnRecent": "Worked on recent tasks",
      "roleOn": "{{role}} on {{n}}",
      "lead": "Lead",
      "noTasks": "No tasks in the last 8 weeks"
    }
  },
  "brandKit": {
    "notFound": "Client not found.",
    "tabs": {
      "colors": "Colors",
      "typography": "Typography",
      "style": "Style",
      "figma": "Figma",
      "assets": "Assets",
      "brand": "Brand doc"
    },
    "readBy": "Read by the Figma Email Designer plugin.",
    "saved": "Saved",
    "saving": "Saving…",
    "save": "Save brand kit",
    "remove": "Remove",
    "copy": "Click to copy",
    "colors": {
      "add": "Add color",
      "addHint": "HEX with optional name and role",
      "namePlaceholder": "Name (e.g. Sunset)",
      "addButton": "Add color",
      "other": "Other",
      "empty": "No colors yet — add one above. Tokens are saved on the next “Save changes”.",
      "token": "Token",
      "contrastWhite": "Contrast {{ratio}} on white",
      "contrastBlack": "Contrast {{ratio}} on black"
    },
    "roles": {
      "primary": "Primary",
      "secondary": "Secondary",
      "accent": "Accent",
      "neutral": "Neutral",
      "semantic": "Semantic"
    },
    "typography": {
      "scale": "Type scale",
      "scaleHint": "Sizes (px) the plugin uses for headings, body copy, and buttons. Email is rendered at 1200px wide.",
      "body": "Body",
      "bodySmall": "Body small",
      "button": "Button",
      "specimens": "Font specimens",
      "specimensEmpty": "Upload .otf / .ttf / .woff / .woff2 — they'll be loaded via @font-face.",
      "specimensLoaded_one": "{{count}} font loaded via @font-face",
      "specimensLoaded_other": "{{count}} fonts loaded via @font-face",
      "uploadFont": "Upload font",
      "dragHint": "Drag-and-drop is in the Assets tab. Files appear here as specimens.",
      "noFonts": "No fonts uploaded yet.",
      "pairings": "Pairings",
      "pairingsHint": "Heading + body combinations to recommend across emails",
      "addPairing": "Add pairing",
      "pairingName": "Pairing {{n}}",
      "removeFont": "Remove font",
      "sampleHeading": "Aa Bb Cc",
      "pangram": "The quick brown fox jumps over the lazy dog. 0123456789",
      "heading": "Heading",
      "sampleTitle": "New season, new shapes.",
      "sampleBody": "A short paragraph in the body face. Built for body copy in your emails — clean, readable on small screens, and consistent with your brand voice."
    },
    "style": {
      "radii": "Radii",
      "radiiHint": "Corner-radius scale. The plugin reads these when building greenfield frames.",
      "small": "Small (sm)",
      "smallHint": "inputs / chips",
      "card": "Card",
      "cardHint": "product cards",
      "section": "Section",
      "sectionHint": "big rounded blocks",
      "pill": "Pill",
      "pillHint": "full-pill buttons",
      "shadows": "Shadows",
      "shadowsHint": "CSS-style recipes — copy verbatim from your tokens.",
      "elevated": "Elevated",
      "buttonSpec": "Button spec",
      "buttonSpecHint": "How CTAs render greenfield: padding, font, transform, radius.",
      "fontFamily": "Font family",
      "fontFamilyHint": "Leave blank to use body pairing",
      "fontFamilyPlaceholder": "e.g. Apercu Pro",
      "paddingY": "Padding Y",
      "paddingX": "Padding X",
      "fontSize": "Font size",
      "fontWeight": "Font weight",
      "weight400": "Regular (400)",
      "weight500": "Medium (500)",
      "weight700": "Bold (700)",
      "transform": "Transform",
      "uppercase": "UPPERCASE",
      "normal": "Normal",
      "letterSpacing": "Letter spacing (em)",
      "radius": "Radius",
      "cardRadius": "Card radius",
      "smallRadius": "Small radius",
      "cardSpec": "Card spec",
      "cardSpecHint": "How product / content cards render greenfield.",
      "gap": "Gap",
      "surface": "Surface",
      "surfacePlaceholder": "#FFFFFF or token name",
      "shadow": "Shadow",
      "cardRecipe": "Card recipe",
      "elevatedRecipe": "Elevated recipe",
      "none": "None"
    },
    "figma": {
      "header": "Header",
      "headerHint": "Logo + nav. Prepended to every email — no AI copy is generated for it.",
      "hero": "Hero",
      "heroHint": "Headline + subhead + primary CTA",
      "body": "Body",
      "bodyHint": "Paragraphs, secondary headings, dividers, in-body CTAs",
      "product": "Product",
      "productHint": "Card grids — image + name + price + CTA",
      "footer": "Footer",
      "footerHint": "Links, address, unsubscribe, social icons",
      "mapping": "Figma component mapping",
      "mappingHint": "When the plugin builds an email for this client, it instantiates these components by name (matched in the current Figma file). Leave blank to fall back to the generic frame builder.",
      "placeholder": "e.g. EmailHero/Default",
      "slots": "Slot convention",
      "slotsHint": "Inside your registered components, name text layers like below to receive generated copy.",
      "layerNames": "Layer names accept any of",
      "or": "or"
    },
    "assets": {
      "logo": "Logo",
      "logoHint": "SVG preferred; PNG works too",
      "replace": "Replace",
      "dropLogo": "Drop logo here, or click to choose",
      "fonts": "Fonts",
      "images": "Images",
      "dropFonts": "Drop fonts here, or click to choose",
      "dropImages": "Drop images here, or click to choose",
      "fileCount_one": "{{count}} file",
      "fileCount_other": "{{count}} files",
      "removeConfirm": "Remove \"{{name}}\"?"
    },
    "doc": {
      "title": "Brand guidelines",
      "hint": "Markdown — voice, palette, type, constraints. Read by /generate."
    }
  },
  "team": {
    "details": {
      "profile": "Profile",
      "email": "Email",
      "emailHint": "Used to sign in with Google",
      "roleTeam": "Role & team",
      "role": "Role",
      "level": "Level",
      "noPod": "No pod",
      "employment": "Employment",
      "login": "Login",
      "loginLinked": "Signed in before",
      "loginNone": "Hasn't signed in yet",
      "deleteHint": "Removes them from tasks, pods and the org chart."
    },
    "tabDetails": "Details",
    "profile": {
      "onDesk": "On their desk",
      "upcoming": "Coming up",
      "clients": "Clients",
      "daysLeft": "Days off left",
      "desk": "On their desk",
      "allTasks": "All tasks →",
      "deskEmpty": "Nothing on their desk right now.",
      "worksOn": "Works on",
      "noClients": "No clients right now.",
      "place": "In the team",
      "team": "Team",
      "noTeam": "Not in a team",
      "pod": "Pod",
      "reportsTo": "Reports to",
      "reports": "Direct reports",
      "timeOff": "Time off",
      "hr": "Time off →",
      "leftOf": "{{left}} of {{total}} days left this year",
      "noLeave": "No time off planned.",
      "pending": "Pending",
      "assigned": "Assigned clients",
      "unassign": "Remove",
      "noneAssigned": "None — their pod and tasks show where they work.",
      "assign": "Assign a client…",
      "approver": "Requests go to",
      "review": "Performance review",
      "reviews": "Reviews →",
      "noReview": "Not in a review cycle yet."
    },
    "eyebrow": "People",
    "eyebrowCount": "People · {{count}}",
    "title": "Team",
    "searchPlaceholder": "Search team…",
    "newEmployee": "New employee",
    "fullName": "Full name",
    "emailPlaceholder": "name@oktoberagency.com",
    "add": "Add",
    "cancel": "Cancel",
    "emptyTitle": "No employees yet",
    "emptyHint": "Add your first team member — their email links them to their Google login.",
    "clientCount_one": "{{count}} client",
    "clientCount_other": "{{count}} clients",
    "noLogin": "no login yet",
    "notFound": "Person not found.",
    "saved": "Saved ✓",
    "saving": "Saving…",
    "deleteConfirm": "Delete {{name}} from the team?",
    "tabOverview": "Overview",
    "tabClients_one": "Clients ({{count}})",
    "tabClients_other": "Clients ({{count}})",
    "tabTasks": "Tasks",
    "basics": "Basics",
    "emailLabel": "Email (used for Google login)",
    "jobTitle": "Job title",
    "teamLabel": "Team",
    "phone": "Phone",
    "statusStructure": "Status & structure",
    "status": "Status",
    "startDate": "Start date",
    "manager": "Manager / mentor (org chart)",
    "managerNone": "— none —",
    "directReports": "Direct reports:",
    "loginLabel": "Login:",
    "loginLinked": "linked ✓",
    "loginNone": "hasn't signed in yet",
    "notes": "Notes",
    "notesPlaceholder": "Internal notes about this person…",
    "deleteEmployee": "Delete employee",
    "worksOn": "Clients {{name}} works on",
    "noClients": "No clients yet.",
    "open": "Open",
    "assigned": "Assigned ✓",
    "assign": "Assign"
  },
  "structure": {
    "eyebrow": "Teams · pods · clients",
    "title": "Structure",
    "unpodded_one": "{{count}} client isn't in a pod yet:",
    "unpodded_other": "{{count}} clients aren't in a pod yet:",
    "ledBy": "led by {{name}}",
    "pod": "Pod {{name}}",
    "clientsCount_one": "{{count}} client",
    "clientsCount_other": "{{count}} clients",
    "openTasksCount_one": "{{count}} open task",
    "openTasksCount_other": "{{count}} open tasks",
    "noLead": "No RM3 lead",
    "floating": "Across teams / not placed",
    "unplaced": "Clients without a team",
    "mentor": "mentor: {{name}}",
    "start": "start {{date}}",
    "new": "new",
    "health": "health {{value}}/5"
  },
  "picker": {
    "search": "Search…",
    "noMatch": "No matches",
    "pickDate": "Pick a date",
    "prevMonth": "Previous month",
    "nextMonth": "Next month",
    "today": "Today",
    "clear": "Clear",
    "done": "Done",
    "hours": "Hours",
    "minutes": "Minutes"
  },
  "reviews": {
    "empty": {
      "title": "No review cycle yet",
      "text": "A cycle gives everyone a self-review and their lead a review to write, rated on our values and the skills of their track."
    },
    "cycleOpen": "Open cycle",
    "cycleClosed": "Closed cycle",
    "dues": "Self-reviews by {{self}} · lead reviews by {{lead}}",
    "completed": "completed",
    "mine": "Your review",
    "notInCycle": "You are not in this cycle.",
    "toWrite": "Reviews you write",
    "how": "How it works",
    "everyone": "Everyone in this cycle",
    "cta": {
      "self": "Write your self-review",
      "waiting": "With {{name}}",
      "read": "Read and acknowledge",
      "view": "View",
      "write": "Write the review"
    },
    "yourLead": "your lead",
    "you": "You",
    "start": {
      "another": "Start another cycle",
      "title": "Start a review cycle",
      "text": "Everyone active gets a self-review; their manager, or whoever approves their time off, writes theirs.",
      "name": "Name",
      "selfDue": "Self-reviews by",
      "leadDue": "Lead reviews by",
      "go": "Start cycle"
    },
    "closeConfirm": "Close this cycle? Reviews stay readable.",
    "close": "Close cycle",
    "reviewOf": "Review · {{cycle}}",
    "reviewedBy": "reviewed by {{name}}",
    "col": {
      "you": "You",
      "self": "Self",
      "lead": "Lead"
    },
    "values": "Our values",
    "skills": "Skills for the role",
    "average": "Average",
    "selfTitleYou": "Your self-review",
    "selfTitle": "Self-review",
    "leadTitle": "Lead's review",
    "overall": "Overall",
    "overallText": "One rating for the whole period",
    "leadHidden": "{{name}} is writing their side; you'll see it once it's shared.",
    "readySelf": "Saved as you go. Send it when you are happy with it.",
    "rateAll": "Rate every value and skill to send it.",
    "sendSelf": "Send to {{name}}",
    "readyLead": "Saved as you go. Share it to let {{name}} read it.",
    "rateAllLead": "Rate every value and skill, and give an overall rating, to share it.",
    "share": "Share with {{name}}",
    "ackText": "Read through it, talk it over with your lead, then acknowledge it.",
    "ack": "Acknowledge",
    "doneOn": "Completed {{date}}",
    "lateSelf": "The self-review was due {{date}}.",
    "goals": "Goals for the next period",
    "removeGoal": "Remove goal",
    "goalPlaceholder": "Add a goal, e.g. \"Own the design system for two clients\"",
    "addGoal": "Add",
    "status": {
      "SELF": "Self-review",
      "LEAD": "With the lead",
      "SHARED": "Shared",
      "DONE": "Done"
    },
    "step": {
      "SELF": "Self-review",
      "LEAD": "Lead review",
      "SHARED": "Talk it over",
      "DONE": "Acknowledged"
    },
    "stepText": {
      "SELF": "You rate yourself on our values and your skills and answer four questions.",
      "LEAD": "Your lead sees it next to theirs, rates you, adds an overall rating and goals.",
      "SHARED": "They share it with you; you talk it through in your next one-on-one.",
      "DONE": "You acknowledge it. The goals carry into the next cycle."
    },
    "value": {
      "deliver": "We deliver",
      "own": "We own it",
      "curious": "We stay curious",
      "impact": "We think about impact"
    },
    "valueText": {
      "deliver": "On time, to the brief, without being chased",
      "own": "Takes problems to the end and speaks up early",
      "curious": "Learns, asks, tries new things",
      "impact": "Thinks about the client's results, not only the task"
    },
    "skill": {
      "strategy": "Strategy",
      "copywriting": "Copywriting",
      "clientRelationship": "Client relationship",
      "data": "Data and reporting",
      "projectManagement": "Project management",
      "designExecution": "Design execution",
      "brandAdaptation": "Adapting to a brand",
      "designSystems": "Design systems",
      "reliability": "Reliability",
      "collaboration": "Collaboration",
      "peopleLeadership": "People leadership",
      "coaching": "Coaching",
      "implementation": "Implementation",
      "klaviyoExpertise": "Klaviyo expertise",
      "qa": "QA and attention to detail",
      "communication": "Communication",
      "delivery": "Team delivery",
      "recruiting": "Hiring"
    },
    "q": {
      "wentWell": "What went well this period?",
      "couldBeBetter": "What could have gone better?",
      "focusNext": "What do you want to focus on next?",
      "support": "What support do you need from your lead?",
      "strengths": "Strengths",
      "growth": "Where to grow",
      "summary": "Summary"
    },
    "scale": {
      "1": "Well below expectations",
      "2": "Below expectations",
      "3": "Meets expectations",
      "4": "Above expectations",
      "5": "Outstanding"
    }
  },
  "client": {
    "intro_one": "{{count}} email is ready for your review.",
    "intro_other": "{{count}} emails are ready for your review.",
    "introNone": "Nothing is waiting for you right now. We will let you know when the next email is ready.",
    "kpi": {
      "review": "Ready for review",
      "reviewHint": "Waiting for your answer",
      "comments": "Open comments",
      "commentsHint": "Yours and ours, not resolved yet",
      "upcoming": "Coming up",
      "upcomingHint": "Sending in the next 30 days",
      "sent": "Sent recently",
      "openRate": "Average open rate {{n}}%",
      "sentHint": "The last emails that went out"
    },
    "review": {
      "title": "Ready for your review",
      "none": "All caught up: nothing is waiting for your review.",
      "changes": "Changes requested",
      "since": "shared {{when}}",
      "cta": "Review"
    },
    "upcoming": {
      "title": "Coming up",
      "none": "Nothing planned for the next 30 days yet.",
      "calendar": "Calendar →"
    },
    "noDate": "Date to be set",
    "sent": {
      "title": "Recently sent",
      "none": "Nothing sent yet.",
      "openRate": "Open rate",
      "opens": "opens",
      "clickRate": "Click rate",
      "clicks": "clicks",
      "all": "All results →"
    },
    "previewing": "You're seeing {{client}}'s view, as {{name}}.",
    "backToMine": "Back to my view",
    "status": {
      "review": "Waiting for your review",
      "production": "In production",
      "building": "Approved, being built",
      "scheduled": "Scheduled",
      "sent": "Sent"
    },
    "portal": "Client portal",
    "sidebar": {
      "none": "Nothing waiting for you",
      "team": "Your Oktober team"
    },
    "nav": {
      "home": "Home",
      "sent": "Sent emails"
    },
    "calendar": {
      "yourTurn": "Your review"
    }
  },
  "review": {
    "toolTitle": "Click the design to comment (C)",
    "comment": "Comment",
    "hint": "Click anywhere on the email to leave a comment there",
    "noDesign": "The design is not ready yet",
    "notConnected": "The design preview is not connected yet",
    "generalOnly": "You can still leave comments on the whole email alongside.",
    "comments": "Comments",
    "showResolved": "Show resolved",
    "noneYet": "No comments yet. Click on the design to add the first one.",
    "noneYetGeneral": "No comments yet.",
    "placeholder": "Add a comment…",
    "post": "Post",
    "general": "Comment on the whole email…",
    "resolved": "Resolved",
    "reply": "Reply…",
    "reopen": "Reopen",
    "resolve": "Resolve",
    "deleteConfirm": "Delete this comment?",
    "delete": "Delete",
    "client": "Client",
    "sends": "Sends {{date}}",
    "openCount_one": "{{count}} open comment",
    "openCount_other": "{{count}} open comments",
    "missing": "This email is not here any more.",
    "openTask": "Open task",
    "approvedBy": "Approved by {{name}} {{when}}",
    "notInReview": "Not waiting for review: it is in {{stage}}.",
    "changesAsked": "Changes requested by {{name}}",
    "seeComments": "See the comments on the design.",
    "yourTurn": "Ready for your review",
    "withClient": "Waiting for the client",
    "yourTurnText": "Leave comments on the design, then approve it or ask for changes.",
    "sentAgo": "Sent to the client {{when}}",
    "withClientText": "The client sees this page and answers here.",
    "askChanges": "Request changes",
    "approve": "Approve",
    "askOptional": "Anything to add to your comments? (optional)",
    "askPlaceholder": "What should change?",
    "sendChanges": "Send to the team",
    "zoom": "Zoom",
    "zoomOut": "Zoom out",
    "zoomReset": "Back to 100% (0)",
    "zoomIn": "Zoom in",
    "teamOnly": "Team only",
    "teamOnlyHint": "The client never sees internal review comments",
    "mode": "Mode",
    "previewTitle": "See the email as it arrives (P)",
    "preview": "Preview",
    "hintPreview": "The email as it arrives. Comments are hidden: switch to Comment to see them.",
    "hiddenInPreview": "Comments are hidden while you preview the email.",
    "backToComments": "Back to comments"
  },
  "sent": {
    "back": "Sent emails",
    "sentOn": "Sent {{date}}",
    "recipients": "{{n}} recipients",
    "sampleHint": "Klaviyo is not connected yet: these are sample numbers.",
    "sample": "Klaviyo · sample data",
    "email": "The email",
    "noDesign": "No design linked to this email",
    "openRate": "Open rate",
    "clickRate": "Click rate",
    "revenue": "Revenue",
    "orders": "Orders",
    "aov": "Average order {{value}}",
    "funnel": "From inbox to order",
    "first48": "Opens in the first 48 hours",
    "first48Hint": "{{share}} opened in the first 6 hours",
    "links": "What people clicked",
    "devices": "Opened on",
    "ctor": "Click-to-open",
    "conversion": "Clicks that ordered",
    "perRecipient": "Revenue per recipient",
    "deliverability": "Deliverability",
    "delivered": "Delivered",
    "bounces": "Bounced",
    "unsubs": "Unsubscribed",
    "spam": "Marked as spam",
    "vsAverage": "vs your average ({{avg}})",
    "opened": "Opened",
    "clicked": "Clicked",
    "ordered": "Ordered",
    "hourTip": "Hour {{h}}: {{n}} opens",
    "clientsOnly": "This is the client's view: preview it as a client from the dashboard.",
    "title": "Sent emails",
    "kpi": {
      "count": "Sent in 30 days",
      "countHint": "{{n}} emails in total",
      "open": "Average open rate",
      "click": "Average click rate",
      "orders": "Orders in 30 days",
      "revenue": "{{value}} revenue",
      "last30": "Last 30 days"
    },
    "col": {
      "email": "Email",
      "recipients": "Recipients"
    },
    "best": "Best open rate"
  },
  "ai": {
    "answeringAs": "Answering as {{name}}",
    "chip": {
      "findCampaigns_one": "Looked at {{count}} campaign",
      "findCampaigns_other": "Looked at {{count}} campaigns",
      "findCampaignsRunning": "Looking at campaigns…",
      "getCampaign": "Opened a campaign",
      "getCampaignRunning": "Opening a campaign…",
      "getCampaignCopy": "Read a campaign's copy",
      "getCampaignCopyRunning": "Reading a campaign's copy…",
      "findClients_one": "Looked at {{count}} client",
      "findClients_other": "Looked at {{count}} clients",
      "findClientsRunning": "Looking at clients…",
      "getClient": "Opened a client",
      "getClientRunning": "Opening a client…",
      "findPeople_one": "Looked at {{count}} person",
      "findPeople_other": "Looked at {{count}} people",
      "findPeopleRunning": "Looking at people…",
      "getPerson": "Opened a profile",
      "getPersonRunning": "Opening a profile…",
      "getStructure": "Looked at the structure",
      "getStructureRunning": "Looking at the structure…",
      "getTimeOff_one": "Looked at {{count}} time off request",
      "getTimeOff_other": "Looked at {{count}} time off requests",
      "getTimeOffRunning": "Checking time off…",
      "getHandbook": "Read the handbook",
      "getHandbookRunning": "Reading the handbook…",
      "createCampaigns_one": "Created {{name}}",
      "createCampaigns_other": "Created {{count}} campaigns",
      "createCampaignsRunning": "Creating campaigns…",
      "updateCampaigns_one": "Updated {{name}}",
      "updateCampaigns_other": "Updated {{count}} campaigns",
      "updateCampaignsRunning": "Updating campaigns…",
      "shiftCampaignDates_one": "Moved the dates of {{name}}",
      "shiftCampaignDates_other": "Moved the dates of {{count}} campaigns",
      "shiftCampaignDatesRunning": "Moving campaign dates…",
      "deleteCampaigns_one": "Deleted {{name}}",
      "deleteCampaigns_other": "Deleted {{count}} campaigns",
      "deleteCampaignsRunning": "Deleting campaigns…",
      "commentOnCampaigns_one": "Commented on {{name}}",
      "commentOnCampaigns_other": "Commented on {{count}} campaigns",
      "commentOnCampaignsRunning": "Commenting on campaigns…",
      "updateClient": "Updated {{name}}",
      "updateClientRunning": "Updating a client…",
      "setClientTeamMember": "Changed a client team",
      "setClientTeamMemberRunning": "Changing a client team…",
      "requestTimeOff": "Requested time off",
      "requestTimeOffRunning": "Requesting time off…",
      "decideTimeOff": "Decided on a time off request",
      "decideTimeOffRunning": "Deciding on a time off request…",
      "updatePersonPlacement": "Changed a person's place in the structure",
      "updatePersonPlacementRunning": "Changing a person's place in the structure…",
      "setLead": "Changed a lead",
      "setLeadRunning": "Changing a lead…",
      "other": "{{tool}}: done",
      "otherRunning": "{{tool}}: running…",
      "failed": "{{tool}} didn't work",
      "tool": {
        "findCampaigns": "Find campaigns",
        "getCampaign": "Open a campaign",
        "getCampaignCopy": "Read a campaign's copy",
        "findClients": "Find clients",
        "getClient": "Open a client",
        "findPeople": "Find people",
        "getPerson": "Open a profile",
        "getStructure": "Look at the structure",
        "getTimeOff": "Check time off",
        "getHandbook": "Read the handbook",
        "createCampaigns": "Create campaigns",
        "updateCampaigns": "Update campaigns",
        "shiftCampaignDates": "Move campaign dates",
        "deleteCampaigns": "Delete campaigns",
        "commentOnCampaigns": "Comment on campaigns",
        "updateClient": "Update a client",
        "setClientTeamMember": "Change a client team",
        "requestTimeOff": "Request time off",
        "decideTimeOff": "Decide on a time off request",
        "updatePersonPlacement": "Change someone's place in the structure",
        "setLead": "Change a lead"
      }
    },
    "ask": "Ask Okto",
    "chats": "Chats",
    "newChat": "New chat",
    "openInChats": "Open in Chats",
    "close": "Close",
    "noChats": "No chats yet",
    "allChats": "All chats",
    "untitled": "Untitled chat",
    "chatActions": "Chat actions",
    "chatTitle": "Chat title",
    "rename": "Rename",
    "delete": "Delete",
    "group": {
      "today": "Today",
      "yesterday": "Yesterday",
      "lastWeek": "Last week",
      "older": "Older"
    },
    "placeholder": "Ask Okto anything…",
    "send": "Send",
    "attach": "Attach files",
    "chatFull": "This chat can't take more files. Start a new chat for them.",
    "file": {
      "uploading": "Uploading…",
      "remove": "Remove {{name}}",
      "open": "Open {{name}}",
      "openFailed": "Couldn't open this file.",
      "drop": "Drop files for Okto",
      "error": {
        "kind": "Okto reads PDF, Word, text, Markdown, CSV and image files.",
        "tooBig": "Too big: this kind of file can be up to {{size}}.",
        "tooLong": "Too long for Okto. Try a shorter file or just the pages you need.",
        "unreadable": "Okto couldn't read this file. It may be empty, damaged or password-protected.",
        "failed": "Couldn't upload this file. Try again.",
        "tooMany": "A message takes up to {{count}} files."
      }
    },
    "loading": "Loading…",
    "thinking": "Okto is thinking…",
    "steps_one": "{{count}} step",
    "steps_other": "{{count}} steps",
    "reset": "Sample data was reset since this chat. Changes above are gone.",
    "refused": "Okto couldn't help with that.",
    "error": "Something went wrong.",
    "retry": "Retry",
    "busy": "This chat is busy in another window. Try again in a moment.",
    "stoppedAfterRounds": "Stopped after {{rounds}} rounds of lookups. Send a message to carry on.",
    "cancelled": "{{tool}}: cancelled",
    "cancelledByReload": "{{tool}}: cancelled by reload",
    "notRun": "{{tool}}: not run",
    "empty": {
      "title": "Hi, I'm Okto",
      "hint": "Ask me about clients, people, campaigns and time off, or ask me to change something. I'll check with you before anything big."
    },
    "confirm": {
      "yes": "Do it",
      "no": "Cancel",
      "more": "and {{count}} more",
      "delete_one": "This deletes {{count}} campaign for good.",
      "delete_other": "This deletes {{count}} campaigns for good.",
      "people_one": "This changes who works on {{count}} campaign.",
      "people_other": "This changes who works on {{count}} campaigns.",
      "clientAdd": "This adds someone to a client's team.",
      "clientRemove": "This takes someone off a client's team.",
      "clientPod": "This moves the client to another pod, which changes its whole team.",
      "placement": "This moves someone in the team structure.",
      "lead": "This changes who leads a team or pod.",
      "approve": "This approves a time off request.",
      "reject": "This declines a time off request.",
      "bulk_one": "This changes {{count}} record.",
      "bulk_other": "This changes {{count}} records.",
      "alreadyDone_one": "{{count}} already changed.",
      "alreadyDone_other": "{{count}} already changed."
    },
    "model": {
      "label": "Model",
      "note": {
        "opus": "Strong all-rounder",
        "sonnet": "Faster, half the price",
        "haiku": "Quickest and cheapest, for simple lookups"
      }
    },
    "admin": {
      "title": "Admin chats",
      "model": {
        "label": "Model for everyone",
        "pick": "Model for everyone: {{model}}",
        "changed": "Everyone now uses {{model}}",
        "changedBy": "Changed by {{name}} · {{when}}",
        "neverChanged": "Default, never changed"
      },
      "unknownUser": "Unknown user",
      "readOnly": "Read only",
      "deletedAccount": "(deleted account)",
      "loadFailed": "Couldn't load the chats.",
      "openFailed": "Couldn't load this chat.",
      "gone": "This chat no longer exists.",
      "back": "All chats",
      "search": "Search question or account",
      "deleted": "deleted",
      "deletedByOwner": "Deleted by owner",
      "slowHint": "A call took 30 s or longer",
      "total": {
        "spend": "Spend",
        "conversations": "Conversations",
        "tokens": "Tokens in / cached / out"
      },
      "col": {
        "when": "When",
        "account": "Account",
        "question": "Question",
        "turns": "Turns",
        "cost": "Cost",
        "model": "Model",
        "time": "Time",
        "status": "Status"
      },
      "tokens": {
        "in": "Tokens in",
        "cached": "Cached",
        "out": "Out"
      },
      "status": {
        "ok": "OK",
        "failed": "Failed",
        "refused": "Refused",
        "stopped": "Stopped"
      },
      "filter": {
        "account": "Account",
        "allAccounts": "All accounts",
        "from": "From",
        "to": "To",
        "tool": "Tool",
        "allTools": "All tools",
        "all": "All",
        "failed": "Failed",
        "slow": "Slow"
      }
    }
  }
}
